module.exports = __webpack_public_path__ + "static/media/google-calendar.9b292fee.svg";